import { isBefore, sub } from "date-fns/esm"

/** Cache acts like a Map expect values are invalidated after a given timeout.
 *
 * const cache = new Cache({ timeout: 10 * 1000 })
 * cache.set("key", "my value")
 * cache.get("key") // "my value"
 * // Wait 10 seconds
 * cache.get("key") // undefined
 */

export class Cache<T> {
  timeoutSeconds: number

  map: Map<string, { time: Date; value: T }> = new Map()

  constructor({ timeoutSeconds }: { timeoutSeconds: number }) {
    this.timeoutSeconds = timeoutSeconds
  }

  set(key: string, value: T) {
    this.map.set(key, { time: new Date(), value })
  }

  get(key: string) {
    const cached = this.map.get(key)

    if (!cached) {
      return undefined
    }

    const isCacheValid = isBefore(sub(new Date(), { seconds: this.timeoutSeconds }), cached.time)
    if (isCacheValid) {
      return cached.value
    } else {
      return undefined
    }
  }
}
